module.exports = __webpack_public_path__ + "staticcomp/img/content_3.1986149.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3/3/content_3.jpg
// module id = 7ez5
// module chunks = 39